import * as React from "react";
import { forwardRef } from "react";
const SvgContactInteractionDirection = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 6.002, height: 6, "data-name": "icon/arrow/incoming", viewBox: "0 0 6.002 6", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 4.934 3.733 1.2H1.282V0H6v4.707H4.832V2.233L1.066 6z", transform: "rotate(180 3.001 3)", fill: "#98a9bc" }));
const ForwardRef = forwardRef(SvgContactInteractionDirection);
export { ForwardRef as ReactComponent };
